import type { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { isStoreGated } from "@/shared/lib/storeGate";
import StoreLanding from "@/pages/store-landing/StoreLanding";

/**
 * prd 브라우저 게이트 2차(라우터 가드, #401).
 *
 * 1차(main.tsx)는 부팅 시 1회만 판정한다. 예외 경로(/terms, /payment/return, /temp)로 부팅된 뒤
 * 내부 이동(/terms 뒤로가기 → / → RootRedirect → /login)은 1차를 안 타므로, 라우트 전환마다
 * 같은 판정을 한 번 더 해 비예외 라우트면 스토어 랜딩만 렌더한다.
 *
 * 배치: RouteErrorBoundary 안, PageTransitionWrapper 바깥 — RootRedirect·TabShell 선택·AuthGuard·
 * TransitionGroup 이 전부 아래에 있어 게이트 시 아무것도 마운트되지 않고 전환 exit 노드도 남지 않는다.
 * `=== "prd"` 리터럴을 조건에 직접 둔다 — 비-prd 빌드에서 StoreLanding 참조가 접힌다.
 */
const StoreGateBoundary = ({ children }: { children: ReactNode }) => {
  const { pathname } = useLocation();
  if (import.meta.env.MODE === "prd" && isStoreGated(pathname)) return <StoreLanding />;
  return <>{children}</>;
};

export default StoreGateBoundary;
